<template>
  <div
    class="background-color-white d-flex flex-column min-height pa-10 rounded-lg"
  >
    <div
      class="primary-color pb-3"
      :class="
        rewardsFormat
          ? 'font-weight-bold font-size-lg'
          : 'font-weight-semibold text-center text-md-left'
      "
    >
      STORE DESCRIPTION
    </div>
    <div class="align-center background-color-white d-flex flex-1">
      <div v-if="storeInfo">
        <div v-if="storeInfo.store_info.blurb" class="white-space-pre-wrap">
          {{ storeInfo.store_info.blurb }}
        </div>
        <div v-else>
          <div class="mb-3">Welcome to {{ wait(storeInfo, "name") }}.</div>
          We hope you enjoy our seamless online shopping experience. This site
          was created for us by
          <a :href="$options.NRS_PLUS" target="_blank" rel="noreferrer"
            >National Retail Solutions, Inc</a
          >, a full-service Point of Sale, payments and retail software company.
        </div>
      </div>
    </div>
    <SocialMedia color="primary" />
  </div>
</template>

<script>
import urls from "@/urls.json";
import { mapGetters, mapState } from "vuex";
import SocialMedia from "@/components/UI/SocialMedia.vue";
import { wait } from "@/util.js";

export default {
  name: "StoreDescription",
  components: { SocialMedia },
  computed: {
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    wait,
  },
  NRS_PLUS: urls.NRS_PLUS,
};
</script>

<style></style>
